import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateStudentProfile } from '@services/registry';

export function useUpdateStudent({ tenantId }) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async ({ studentId, patch }) => {
            return await updateStudentProfile({ tenantId, studentId, patch });
        },
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['students', tenantId] });
            qc.invalidateQueries({ queryKey: ['studentKpis', tenantId] });
        },
    });
}

